<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop : true }"></ngx-loading>
<div class="card" style="height:100%; overflow: hidden">
  <div class="card-header">
    <div class="row">
      <div class="col-12 text-center">
        <h4 style="color:#9b7544">
          <span><strong>Password Reset</strong></span>
        </h4>
      </div>
    </div>
  </div>
  <div class="card-body">
      <div class="row" *ngIf="oldpasswordflag == 0">
          <div class="col-12 text-center">
            <div class="form-group"style=" margin:0px" >
                <label for="oldpass">Old Password</label>
                <input   type="password" name="name" id="name"  class="form-control" [(ngModel)]="oldpass" required>
            </div>
          </div>
          <div class="col-12 text-center" *ngIf="msg">
            <span style=" font-style: open sans; color:red">{{msg}}</span>
          </div>
          <div class="col-12 text-center" *ngIf="oldpass && oldpasswordflag == 0 " style=" margin:0px; margin-top:2px">
            <button class="btn btn-success " (click)="checkUserPass()">Next</button>
          </div>
        </div>
  </div>
  
  <div class="row" style="bottom:2px; position:absolute;width:100%; margin:0px">
      <div class="col-12">
          <button class="btn btn-success2 btn-block" mat-dialog-close>cancel</button>
        </div>
  </div>
  <div  *ngIf="oldpasswordflag == 1">
    <form style=" margin-bottom: 200px">
        <div class="form-group"style=" margin:10px" >
            <label for="np">Enter New Password</label>
            <input   type="password" name="np" id="np" [(ngModel)]="np"  class="form-control" required>
        </div>
        <div class="form-group"style=" margin:10px" >
            <label for="cnp">Confirm Password</label>
            <input   type="password" name="cnp" id="cnp" [(ngModel)]="cnp"  class="form-control"  required>
        </div>
        <div style=" margin-left: 120px; color: red"  class="error" *ngIf="np && cnp && np !==cnp">password do not match</div>
    </form>
     <div class="row"  *ngIf="np && cnp && np === cnp">
       <div class="col-12 text-centre" style="margin-top:2%">
         <button style="margin-top: -350px; margin-left: 130px" class="btn btn-success" (click)="passwordChange()">Change Password</button>
       </div>
     </div>
  </div>
</div>
